import { defineComponent, computed, ref } from "vue";
import { reduceFileAccept } from "@/common/file";
import { getApiPath } from "@/common/api-proxy.js";
import { definePropType } from "@types-vue/props";
import { v2Host } from "@/config/host";
import { Message } from "element-ui";
export default defineComponent({
    name: "upload-modular",
    props: {
        uploadConfig: {
            type: definePropType(Object),
            default: function() {
                return {};
            }
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var uploadList = ref([]);
        var hideUpload = ref(false);
        var dialogVisible = ref(false);
        var limitCount = ref(1);
        var dialogImageUrl = ref("");
        var uploadIcon = computed(function() {
            if (props.uploadConfig.type === "thumb") {
                return "el-icon-plus";
            }
            return "el-icon-upload";
        });
        var accept = computed(function() {
            return reduceFileAccept(props.uploadConfig.accept);
        });
        var uploadFileUrl = computed(function() {
            return "".concat(v2Host).concat(getApiPath("/upload/file"));
        });
        var handleUploadChange = function(file, fileList) {
            hideUpload.value = fileList.length >= limitCount.value;
        };
        var handleUploadRemove = function(file, fileList) {
            // uploadList.value = fileList
            hideUpload.value = uploadList.value.length >= limitCount.value;
            emit("on-remove");
        };
        var handleUploadPreview = function(file) {
            dialogImageUrl.value = file.url;
            dialogVisible.value = true;
        };
        var handleUploadError = function(res, file, fileList) {
            Message({
                message: res.msg || "\u4E0A\u4F20\u5931\u8D25",
                type: "error"
            });
            handleUploadRemove(file, fileList);
        };
        var handleUploadSuccess = function(res, file, fileList) {
            if (Number(res.code) === 0) {
                if (fileList.length > 1) {
                    fileList.splice(0, 1);
                }
                emit("on-success", res.data.file_path);
            } else {
                handleUploadError(res, file, fileList);
            }
        };
        return {
            accept: accept,
            uploadIcon: uploadIcon,
            hideUpload: hideUpload,
            limitCount: limitCount,
            uploadList: uploadList,
            uploadFileUrl: uploadFileUrl,
            dialogVisible: dialogVisible,
            dialogImageUrl: dialogImageUrl,
            handleUploadRemove: handleUploadRemove,
            handleUploadSuccess: handleUploadSuccess,
            handleUploadChange: handleUploadChange,
            handleUploadError: handleUploadError,
            handleUploadPreview: handleUploadPreview
        };
    }
});
